import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Flex, Loader, MultiSelect, Stack, Text, Title } from "@mantine/core";
import { useEffect, useState } from "react";
import { AppModal } from "../../shared/AppModal";
import { PriorityEmailType, useCreatePriorityEmailRecordMutation, useGetTherapyCategoryListQuery } from "../../graphql/graphql";
import { showErrorNotification, showSuccessNotification } from "../../shared/Notifications";
export const GlobalInviteModal = ({ priorityEntryId, therapyCategoryIds, opened, close }) => {
    // State
    const [tcIds, setTcIds] = useState([]);
    const [error, setError] = useState(null);
    // Reset state when modal opens
    useEffect(() => {
        if (opened) {
            setTcIds(therapyCategoryIds);
            setError(null);
        }
    }, [opened, therapyCategoryIds]);
    // Queries
    const [{ data, fetching }] = useGetTherapyCategoryListQuery({
        pause: !opened
    });
    // Mutations
    const [{ fetching: fetchingCreatePriorityEmailRecord }, createPriorityEmailRecord] = useCreatePriorityEmailRecordMutation();
    // Handlers
    const handleInviteToGlobalQueue = async () => {
        if (tcIds.length < 1) {
            setError("Please, choose at least one therapy.");
            return;
        }
        else {
            createPriorityEmailRecord({
                input: {
                    priorityEntryId: priorityEntryId,
                    priorityEmailType: PriorityEmailType.PriorityGlobalInvite,
                    therapyCategoryIds: tcIds
                }
            })
                .then(() => {
                close();
                showSuccessNotification("Priority entry released to global list");
            })
                .catch(() => {
                showErrorNotification("Failed to release priority entry to global list");
            });
        }
    };
    const handleClose = () => {
        setTcIds([]);
        setError(null);
        close();
    };
    return (_jsx(AppModal, { title: _jsxs(Flex, { gap: "sm", align: "center", children: [_jsx(Title, { order: 4, lineClamp: 1, children: "Invite to Global Referrals" }), fetching && _jsx(Loader, { size: "xs" })] }), opened: opened, onClose: handleClose, children: _jsxs(Stack, { style: { gap: "1.5rem" }, children: [_jsx(Text, { variant: "body", children: "Please, choose therapies to place in global referrals for this patient." }), _jsx(MultiSelect, { required: true, label: "Therapies", placeholder: "Choose therapies", searchable: true, clearable: true, value: tcIds, styles: {
                        pill: {
                            backgroundColor: "var(--mantine-color-primary-4)"
                        }
                    }, data: data?.therapyCategories?.therapyCategoriesList ?? [], error: error, onChange: (value) => {
                        setError(null);
                        setTcIds(value);
                    } }), _jsx(Button, { variant: "filled", loading: fetchingCreatePriorityEmailRecord, onClick: handleInviteToGlobalQueue, children: "Invite" })] }) }));
};
